export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/VN-ee1b946d8de8ad10b56f7f11a129b812.png";